<template>
  <component :is="getIcon" class="logo" />
</template>

<script>
export default {
  name: 'Logo',

  components: {
    SvgBrand: () => import('@/assets/svgs/logo.svg?inline'),
  },

  computed: {
    getIcon() {
      return `svg-brand`;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: rem(55);
  path {
    fill: $white;
  }
}
</style>
